<footer class="app-footer">
  <div class="footer-container">
    <div class="footer-left">
      <span class="copyright"> © {{ currentYear }} <strong>Go Roaming</strong> by Tecknovate </span>
    </div>
  </div>
</footer>
